import * as AUTHACTIONS from '../../actions/auth.action'

const initialState = {
    loading: false,
    success: false,
    failure: false,
    status:'',
    status_code:'',
    message:'',
    data:[]
}

export default function returnstate(state = initialState, action) {

    switch (action.type) {
        case AUTHACTIONS.SEND_LOGIN_OTP.REQUEST:
            return {
                ...state,
                loading: true,
                success: false,
                failure: false,
            };
        case AUTHACTIONS.SEND_LOGIN_OTP.SUCCESS:     
        return {
                ...state,
                loading: false,
                success: true,
                failure: false,
                status:action.payload.status,
                status_code:action.payload.status_code,
                message:action.payload.message,
                data:action.payload.data
            };

        case AUTHACTIONS.SEND_LOGIN_OTP.FAILURE:
            return {
                ...state,
                loading: false,
                success: false,
                failure: true,
                status:action.payload.status,
                status_code:action.payload.status_code,
                message:action.payload.message,
                data:action.payload.data
            };

        case AUTHACTIONS.RESET_SEND_LOGIN_OTP.SUCCESS:
                return {
                    ...state,
                    loading: false,
                    success: false,
                    failure: false,
                    status:'',
                    status_code:'',
                    message:'',
                    data:[]
                };
        default: return state
    }
}